import { createContext } from 'react'

import { prepareDictionary } from './helpers'

import type { DictionaryContextValue } from './types'

export const DictionaryContext = createContext<DictionaryContextValue>({
  terminology: null,
  isPwCUser: null,
  dictionary: prepareDictionary(),
})
